import React, { useState, useEffect } from 'react';
import AvatarCard from '../features/avatar/AvatarCard';
import { generateRandomAvatar } from '../features/avatar/avatarUtils';
import './AvatarGalleryPage.css';

function AvatarGalleryPage() {
  const [avatars, setAvatars] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Initialize with 20 random avatars
  useEffect(() => {
    const initialAvatars = Array.from({ length: 20 }, () => generateRandomAvatar());
    setAvatars(initialAvatars);
    setIsLoading(false);
  }, []);

  // Regenerate a single avatar
  const handleRegenerateOne = (index) => {
    const newAvatar = generateRandomAvatar();
    setAvatars(prev => {
      const updated = [...prev];
      updated[index] = newAvatar;
      return updated;
    });
  };

  // Regenerate all avatars
  const handleRegenerateAll = () => {
    const newAvatars = Array.from({ length: 20 }, () => generateRandomAvatar());
    setAvatars(newAvatars);
  };

  if (isLoading) {
    return <div className="avatar-gallery-loading">生成头像中...</div>;
  }

  return (
    <div className="avatar-gallery-container">
      <header className="gallery-header">
        <h1 className="gallery-title">
          <span className="title-gradient">Avatar Gallery</span>
        </h1>
        <button className="btn-regenerate-all" onClick={handleRegenerateAll}>
          🎲 全部刷新
        </button>
      </header>

      <div className="avatar-grid">
        {avatars.map((avatar, index) => (
          <AvatarCard
            key={index}
            avatarData={avatar}
            onRegenerate={handleRegenerateOne}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}

export default AvatarGalleryPage;
